import * as actionTypes from "../../actions/actionTypes";

const nudgePermission = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_NUDGE_PERMISSION:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default nudgePermission;
